const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconSBadgeCheckXl(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    xmlnsserif: "http://www.serif.com/",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    id: "iconS-badge-check-XL",
    x: 0,
    y: 0,
    width: 40,
    height: 40,
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "iconS-badge-check-XL1",
    serifid: "iconS-badge-check-XL"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M36,20c-0,-2.356 -1.481,-4.369 -3.569,-5.15c0.919,-2.025 0.55,-4.494 -1.119,-6.162c-1.668,-1.669 -4.137,-2.038 -6.162,-1.119c-0.781,-2.088 -2.794,-3.569 -5.15,-3.569c-2.356,-0 -4.369,1.481 -5.15,3.569c-2.025,-0.919 -4.5,-0.55 -6.163,1.119c-1.668,1.668 -2.037,4.137 -1.118,6.162c-2.088,0.781 -3.569,2.794 -3.569,5.15c-0,2.356 1.481,4.369 3.569,5.15c-0.919,2.025 -0.55,4.5 1.118,6.162c1.663,1.663 4.132,2.044 6.163,1.119c0.781,2.082 2.794,3.569 5.15,3.569c2.356,0 4.369,-1.481 5.15,-3.569c2.037,0.925 4.5,0.544 6.162,-1.119c1.669,-1.668 2.038,-4.137 1.119,-6.162c2.088,-0.781 3.569,-2.794 3.569,-5.15Z",
    style: {
      fill: "#fff",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36,20c-0,2.356 -1.481,4.369 -3.569,5.15c0.919,2.025 0.55,4.494 -1.119,6.163c-1.662,1.662 -4.125,2.043 -6.162,1.118c-0.781,2.088 -2.794,3.569 -5.15,3.569c-2.356,0 -4.369,-1.487 -5.15,-3.569c-2.031,0.925 -4.5,0.544 -6.163,-1.118c-1.668,-1.663 -2.037,-4.138 -1.118,-6.163c-2.088,-0.781 -3.569,-2.794 -3.569,-5.15c-0,-2.356 1.481,-4.369 3.569,-5.15c-0.919,-2.025 -0.55,-4.494 1.118,-6.162c1.663,-1.669 4.138,-2.038 6.163,-1.119c0.781,-2.088 2.794,-3.569 5.15,-3.569c2.356,0 4.369,1.481 5.15,3.569c2.025,-0.919 4.494,-0.55 6.162,1.119c1.669,1.668 2.038,4.137 1.119,6.162c2.088,0.781 3.569,2.794 3.569,5.15Zm-10.134,-6.195l-7.53,9.512l-4.427,-3.504c-0.616,-0.489 -1.513,-0.384 -2.001,0.232c-0.489,0.617 -0.384,1.514 0.232,2.002l5.545,4.389c0.617,0.488 1.513,0.384 2.002,-0.233l8.413,-10.629c0.488,-0.617 0.384,-1.514 -0.233,-2.002c-0.616,-0.488 -1.513,-0.384 -2.001,0.233Z",
    style: {
      fillRule: "nonzero"
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSBadgeCheckXl);
export default __webpack_public_path__ + "static/media/iconS-badge-check-XL.30c50b8531d60427fdab903862a2c641.svg";
export { ForwardRef as ReactComponent };